import React from "react";

const InputText = ({ label, name, set, val, error }) => {
  const errMsg = error?.find((err) => err.param === name)?.msg;
  
  return (
    <div>
      <label
        htmlFor={name}
        className="block mb-2 text-sm font-sans text-gray-700 font-bold"
      >
        {label}
      </label>
      <input
        type="text"
        name={name}
        id={name}
        value={val}
        onChange={(e) => set(e.target.value)}
        className="bg-gray-50 ring-1 border-0 ring-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 block w-full p-2 font-sans"
        placeholder="username"
        required
      />
      {errMsg && (
        <p className="mt-1 text-sm text-red-600 font-sans">{errMsg}</p>
      )}
    </div>
  );
};

export default InputText;
